import { useMemo } from 'react'
import { LOCATION_ADDING_FORM_VALUES } from 'texts/locationDetails'
import { minMaxPeriodDayValidation } from '../utils'

export const useReservationRules = (formValues: Record<string, unknown>) => {
  const rules = useMemo(
    () => ({
      dailyRangeRules: [
        {
          type: 'required',
          message:
            LOCATION_ADDING_FORM_VALUES.DRIVER_AGE_RANGE.REQUIRED_MESSAGE,
        },
      ],
      minimumPeriodDay: [
        {
          type: 'required',
          message:
            LOCATION_ADDING_FORM_VALUES.MINIMUM_PERIOD_DAY.VALIDATION_MESSAGE,
        },
        {
          type: 'custom',
          value: (value: string) =>
            Number(value) < 1
              ? {
                  message:
                    LOCATION_ADDING_FORM_VALUES.MINIMUM_PERIOD_DAY
                      .VALIDATION_MESSAGE,
                }
              : false,
        },
      ],
      minMaxPeriodDay: [
        {
          type: 'custom',
          value: () =>
            minMaxPeriodDayValidation(formValues)
              ? {
                  message:
                    LOCATION_ADDING_FORM_VALUES.MIN_MAX_RENTAL_DAYS
                      .VALIDATION_MESSAGE,
                }
              : false,
        },
      ],
    }),
    [formValues]
  )

  return rules
}
